import { ColumnFilter } from "./ColumnFilter";
import moment from 'moment';
import "./ColumnHead_new.css"

export const ColumnHead = [
  {
    Header: "SI. #",
    width: 70,
    accessor: "SId",
    Cell: ({ row }) => (
      <p style={{ textAlign: "center", fontSize:"14px",paddingTop:"12px" }}>{row.index + 1}</p>
    ),
    Filter: "",
    HeaderName:"SId",
    Img:""
  },
  {
    Header: "Course Name",
    accessor: "CourseName",
    width:200,
    Cell: ({ row }) => (
      <p style={{ textAlign: "left", fontSize:"14px",paddingTop:"12px" }}>{row.original['CourseName']}</p>
    ),
    Filter: ColumnFilter,
    HeaderName:"CourseName",
    Img:<img
    src={process.env.PUBLIC_URL + "/images/Calendar/nml-filter-icon.png"}
    width={60}
    alt='Filter-icon'
    className='Filter-icon'
  />
  },
  {
    Header: "Start Date", 
    accessor: 'SessionStartDate',
    Cell: ({ row }) => (
      <p style={{ textAlign: "center", fontSize:"14px",paddingTop:"12px" }}>{moment(row.original['SessionStartDate']).format('DD/MM/YYYY')}</p>
    ),
    Filter: ColumnFilter,
    HeaderName:"SessionStartDate",
    Img:<img
    src={process.env.PUBLIC_URL + "/images/Calendar/nml-filter-icon.png"}
    width={60}
    alt='Filter-icon'
    className='Filter-icon'
  />
  },
  {
    Header: "End Date ", 
    accessor: "SessionEndDate",
    Cell: ({ row }) => (
      <p style={{ textAlign: "center", fontSize:"14px",paddingTop:"12px" }}>{moment(row.original['End Date']).format('DD/MM/YYYY')}</p>
    ),
    Filter: ColumnFilter,
    HeaderName:"SessionEndDate",
    Img:<img
    src={process.env.PUBLIC_URL + "/images/Calendar/nml-filter-icon.png"}
    width={60}
    alt='Filter-icon'
    className='Filter-icon'
  />
  },
  {
    Header: "Delivery Mode",
    accessor: "Mode of Delivery",
    Filter: "",
    HeaderName:"Mode of Delivery",
    Img:<img
    src={process.env.PUBLIC_URL + "/images/Calendar/nml-filter-icon.png"}
    width={60}
    alt='Filter-icon'
    className='Filter-icon'
    />
  },
  {
    Header: "Category ",
    accessor: "Category",
    Filter: "",
    HeaderName:"Category",
    Img:""
  },
  {
    Header: "Duration (hrs)",
    accessor: "Duration",
    Cell: ({ row }) => (
      <p style={{ textAlign: "center", fontSize:"14px",paddingTop:"12px" }}>{row.original['Training Duration']}</p>
    ),
    Filter: "",
    HeaderName:"Duration"
  },
  {
    Header: "Registration Link",
    Cell: ({ row }) => (
      <a
        style={{ textDecoration: "none", color: "#7500c0" }}
        href={row.original['Registration Link']}
        target="_blank"
        rel="noreferrer"
      >
        Register
      </a>
    ),
    Filter: "",
    HeaderName:"Registration Link",
    Img:""
  },
  {
    Header: "Target Audience Level ",
    accessor: "Target Audience Level",
    Filter: "",
    HeaderName:"Target Audience Level",
    Img:""
  }
  ,
   {
    Header: "Course Update",
    accessor: "Course Update",
    Filter: "",
    HeaderName:"Course Update",
    Img:""
  }
];